export const kreatorPath =
    process.env.NEXT_PUBLIC_KREATOR_BASE_URL ||
    'https://kreator.viakonnect.com';
export const whatsApp = process.env.NEXT_PUBLIC_WHATSAPP || '33648517574';
